import React from "react";
import styles from "./countdownToRecord.module.css";

export default function CountdownToRecord({ currentCount }) {
  return <div className={styles.countdownToRecord}>{currentCount}</div>;
}
